import { accentInsensitivePattern } from "@/shared/utils/text-search";

/**
 * O destaque da busca dentro das justificativas (2026-10-20).
 *
 * O servidor casa sem caixa e, desde 2026-10-30, sem acento, com `%`/`_`
 * valendo como texto (`core/mention_search.py::text_contains`), então o
 * destaque faz a mesma pergunta: a expressão regular de
 * `accentInsensitivePattern` — as mesmas classes de letra do servidor —
 * com a flag `i`. "saude" marca "Saúde", e só o que a lista casou.
 *
 * Só marca o que está no texto exibido. A frase de termos é montada pela
 * tela (`"rombo"; "crise"`) a partir da gravada (`rombo; crise`), então
 * uma busca que atravessa o separador casa no servidor e não marca nada
 * aqui — a menção continua na lista, e é isso que importa.
 */

export type MarkedSegment = { text: string; hit: boolean };

/** O texto cortado em pedaços, cada um dizendo se casa com a busca. Busca
 *  vazia (ou só espaços) devolve o texto inteiro, sem destaque. */
export function splitMarks(text: string, query: string): MarkedSegment[] {
  const needle = query.trim();
  if (!text || !needle) return [{ text, hit: false }];
  const pattern = new RegExp(accentInsensitivePattern(needle), "gi");
  const segments: MarkedSegment[] = [];
  let cursor = 0;
  for (const match of text.matchAll(pattern)) {
    const start = match.index ?? 0;
    if (start > cursor) segments.push({ text: text.slice(cursor, start), hit: false });
    segments.push({ text: match[0], hit: true });
    cursor = start + match[0].length;
  }
  if (cursor < text.length) segments.push({ text: text.slice(cursor), hit: false });
  return segments.length ? segments : [{ text, hit: false }];
}
